<template>
  <div>
    <div class="px-3 py-2">
      <div class="row">
        <div class="col-md-12 col-lg-12 col-sm-12 mt-2">
          <div class="text-end">
            <div class="">
              <div class="btn-group">
                <button
                  type="button"
                  class="btn btn-bm-noradius bg-main text-white h-100"
                  @click="mtdBackCampus"
                >
                  <i class="fas fa-recycle"></i><br />Cambiar de sede
                </button>
              </div>
              &nbsp;
              <div class="btn-group">
                <button
                  type="button"
                  class="btn btn-bm-noradius bg-main text-white h-100"
                  @click="mtdCloseBead"
                >
                  <i class="fas fa-cash-register"></i><br />Cerrar
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12 col-lg-12 col-sm-6 mt-3">
          <div class="text-center p-5">
            <div
              class="d-grid gap-2 mx-auto col-lg-3 col-md-3 col-sm-12 col-xs-12"
            >
              <button
                class="btn btn-lg bg-main text-white mt-100"
                @click="generarVenta"
                type="button"
              >
                VENTA DIRECTA
              </button>
              <button
                class="btn btn-lg bg-main text-white mt-100"
                @click="generarOrdenTrabajo"
                type="button"
              >
                ORDEN DE TRABAJO
              </button>
              <button
                class="btn btn-lg bg-main text-white mt-100"
                @click="generarEgreso"
                type="button"
              >
                EGRESO
              </button>
            </div>
          </div>
        </div>
        <!-- Venta -->
        <div class="col-md-12 col-lg-12 col-sm-6">
          <div class="row p-1">
            <div class="col-md-12 col-lg-8 col-xl-6 px-sm-2 px-md-4">
              <div class="row d-flex">
                <div id="btn_refresh" class="col-md-12">
                  <button type="button" @click="mtdCleanClient" class="btn">
                    <i class="fa fa-repeat"></i>
                  </button>
                </div>
                <div class="col-md-3 p-2 mt-200">
                  <input
                    class="form-control form-control-lg inpunt-rounded"
                    type="text"
                    @keypress="isNumber($event)"
                    v-model="client.document"
                    @keypress.enter="mtdSearchDocument"
                    maxlength="12"
                    placeholder="Documento"
                    aria-label=".form-control-lg example"
                  />
                </div>
                <div class="col-md-9 p-2">
                  <input
                    class="form-control form-control-lg inpunt-rounded"
                    type="text"
                    v-model="client.fullName"
                    :disabled="disabledPatient"
                    placeholder="Nombres y apellidos del paciente"
                    aria-label=".form-control-lg example"
                  />
                </div>
                <div class="col-md-3 p-2">
                  <input
                    class="form-control form-control-lg inpunt-rounded"
                    type="text"
                    v-on:keypress="isNumber($event)"
                    v-model="client.celphone"
                    maxlength="9"
                    placeholder="Teléfono"
                    aria-label=".form-control-lg example"
                  />
                </div>
                <div class="col-md-6 p-2">
                  <input
                    class="form-control form-control-lg inpunt-rounded"
                    type="text"
                    v-model="client.email"
                    placeholder="Correo del paciente"
                    aria-label=".form-control-lg example"
                  />
                </div>
                <div class="col-md-3 p-2">
                  <input
                    class="form-control form-control-lg inpunt-rounded"
                    type="text"
                    v-on:keypress="isNumber($event)"
                    @keyup="mtdVerifEdad"
                    v-model="client.yearOld"
                    maxlength="3"
                    placeholder="Edad"
                    aria-label=".form-control-lg example"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <SweetAlert :swal="swal" ref="SweetAlert" />
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import SweetAlert from "@/components/shared/SweetAlert/SweetAlert.vue";

export default {
  name: "c-Admision-home",
  props: {
    verifBead: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    SweetAlert,
  },
  data() {
    return {
      page: null,
      disabledPatient: true,
      swal: null,
      client: {
        document: "",
        celphone: "",
        email: "",
        fullName: "",
        yearOld: "",
        type: "particular",
        insurance: null,
        copago: "",
        fijo: "",
      },
      insurances: [],
    };
  },
  created() {;
    //this.mtdGetData();
  },
  methods: {
    ...mapActions(["get", "post"]),
    
    mtdGetData: function () {
      this.get({
        url: this.$store.getters.get__url + "/Admision/listInsurances",
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.insurances = response.data;
        })
        .catch(() => {});
    },

    mtdSearchDocument: function () {
      let length = this.client.document.length;

      if (length < 8) {
        this.$refs.SweetAlert.showWarning(
          "Debe ingresar 8 dígitos cómo mínimo"
        );
        return;
      }

      switch (length) {
        case 8:
          this.mtdSendRequestForDni(); //Enviar petición para DNI - 8 Dígitos
          break;
        case 9:
          this.mtdSendRequestForCE(); //Enviar para CE - 9 Dígitos
          break;
        default:
          this.disabledPatient = false;
          this.client.celphone = "";
          this.client.email = "";
          this.client.fullName = "";
          this.client.yearOld = "";
          break;
      }
    },
    mtdSendRequestForDni() {
      this.get({
        url: `${this.$store.getters.get__url}/reniec/${this.client.document}`,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          if (response.data.boo === 3) {
            this.$refs.SweetAlert.showWarning("DNI no encontrado");
            this.disabledPatient = false;
            this.client.fullName = "";
          } else {
            this.client.fullName = `${response.data.name} ${response.data.last_name}`;
            if (response.data.hasOwnProperty("patient")) {
              this.client.celphone = response.data.patient.phone;
              this.client.email = response.data.patient.email;
              this.client.yearOld = response.data.patient.year;
            } else {
              this.client.celphone = "";
              this.client.email = "";
              this.client.yearOld = "";
              this.disabledPatient = true;
            }
          }
        })
        .catch((errors) => {
          console.log(errors);
        });
    },
    mtdSendRequestForCE() {
      this.get({
        url: `${this.$store.getters.get__url}/cee/${this.client.document}`,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          if (response.statusCode !== 200) {
            this.$refs.SweetAlert.showWarning(
              "Número de documento no encontrado"
            );
            this.disabledPatient = false;
            this.client.fullName = "";
            this.client.celphone = "";
            this.client.email = "";
            this.client.yearOld = "";

            return;
          }

          let patient = response.data.patient;

          this.client.fullName = patient.name;
          this.client.celphone = patient.phone ?? "";
          this.client.email = patient.email ?? "";
          this.client.yearOld = patient.year ?? "";
        })
        .catch((error) => {
          console.log(error);
        });
    },
    mtdSelectType: function (type) {
      this.client.type = type;
    },
    mtdSelectEps: function (id) {
      this.client.insurance = id;
    },
    mtdCleanClient: function () {
      this.disabledPatient = true;
      this.client = {
        document: "",
        celphone: "",
        email: "",
        fullName: "",
        yearOld: "",
        type: "",
        insurance: null,
        copago: "",
        fijo: "",
      };
    },
    mtdVerifClient() {
      const { client } = this;
      if (!client.document.trim())
        return { msg: "Ingrese datos del cliente", status: false };
      // if (!client.yearOld || !client.yearOld.trim())
      //   return { msg: "Ingrese edad.", status: false };
      // if (!client.type.trim()) return { msg: "Escoja un tipo.", status: false };

      if (client.type === "eps" && !client.insurance) {
        return { msg: "Escoja un seguro Eps", status: false };
      }

      if (!client.celphone) {
        return { msg: "Ingrese N° de Telefono", status: false };
      }

      return { msg: "Cliente válido", status: true };
    },

    generarVenta: function () {
      let clientValid = this.mtdVerifClient();

      if (clientValid.status) {
        this.$emit("mtdChangePage", "venta", this.client);
      } else {
        this.$refs.SweetAlert.showWarning(clientValid.msg);
      }
    },

    generarOrdenTrabajo: function () {
      let clientValid = this.mtdVerifClient();

      if (clientValid.status) {
        this.$emit("mtdChangePage", "orden", this.client);
      } else {
        this.$refs.SweetAlert.showWarning(clientValid.msg);
      }
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    generarEgreso() {
      this.$emit("mtdChangePage", "egreso", this.client);
    },
    otrasViews() {
      this.$emit("mtdChangePage", "laboratorio"); // Cambiar por views: 'imagenes', 'topico', 'laboratorio'
    },
    mtdVerifEdad: function () {
      if (!this.client.yearOld || this.client.yearOld.length <= 0) {
        return;
      }

      if (this.client.yearOld > 110) {
        this.client.yearOld = "";
        this.$refs.SweetAlert.showWarning("Edad incorrecta");
      }
    },
    mtdCloseBead() {
      this.$emit("mtdChangePage", "close");
    },
    mtdHc() {
      this.$emit("mtdChangePage", "Hc");
    },
    mtdBackCampus: function () {
      this.$emit("mtdBackCampus");
    },
  },
};
</script>

